import React, {useState} from 'react';

const InputField = ({title, type, className, name, value, onChange, disabled}) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div className={`relative bg-transparent ${className}`} dir="rtl">
            <input
                type={type ?? 'text'}
                name={name}
                disabled={disabled}
                value={value ?? ""}  // Controlled input
                onChange={onChange}  // Uses parent's state handler
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(value !== '')}
                className={`w-full px-4 pt-5 pb-3 z-2 text-xl xl:text-md outline-0 border-2 rounded-md appearance-none transition-all disabled:bg-gray-200 peer text-right ${isFocused && !disabled ? 'border-light-primary' : 'border-gray-200'}`}
            />
            <label
                className={`absolute right-4 text-gray-400 z-1 text-lg xl:text-md transition-all px-1 ${
                    isFocused || value ? 'top-1 text-md xl:text-sm text-light-primary' : 'top-1/3 -translate-y-1/2'
                } ${disabled ? 'hidden' : 'block'}`}
            >
                {title}
            </label>
        </div>
    );
};

export default InputField;
